import styled from 'styled-components'

export const Codes = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
`

export const Code = styled.div`
  width: 400px;
  min-height: 210px;
  border-radius: 15px;
  padding: 10px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;

  background: #e5e7e9;
`

export const CodeContent = styled.div`
  flex: 1;
`

export const AccountTitle = styled.h1`
  font-size: 14px;
  font-weight: bold;
  color: #2d3277;
  text-align: center;
  padding: 4px;
`

export const DateSection = styled.div`
  margin: 10px 0;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`

export const AccountDate = styled.p`
  margin: 0;
  font-size: 10px;
  font-weight: bold;
  text-align: center;
  padding: 4px;
  color: ${({ color }) => color};
`

export const AccountTotal = styled.p`
  font-size: 16px;
  font-weight: bold;
  color: #2d3277;
  text-align: center;
`
